import axios from "axios";

const axiosInstanceWithoutInterceptor = axios.create();
export default axiosInstanceWithoutInterceptor;
